export enum Constants {
    ADD_EDUCATION_REPORT = 'ADD_EDUCATION_REPORT',
    UPDATE_EDUCATION_REPORT = 'UPDATE_EDUCATION_REPORT',
    REMOVE_EDUCATION_REPORT = 'REMOVE_EDUCATION_REPORT'
}